import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useMemo, useState } from 'react';

import RenderGameIcon from '@/pages/opinion/components/RenderImg/renderGameIcon';
import RegionCountryItem from '@/pages/opinion/components/Snippets/RegionCountryItem';
import { initialUpperCase } from '@/pages/opinion/utils';
import { getCompetitorGameCountryPublisher } from '@/pages/opinion/services';
import { useIntl } from 'umi';

export default function HeaderGame({ gameInfo }: { gameInfo: any }) {
  const { formatMessage } = useIntl();
  const [gameOtherInfo, setGameOtherInfo] = useState({
    publisher: '',
    country: '',
  });

  const { entity_name, edition_unified_id, id_type, entity_type } =
    gameInfo || {};

  useEffect(() => {
    if (!gameInfo) return;
    getCompetitorGameCountryPublisher({
      games: [
        {
          edition_unified_id: edition_unified_id,
          entity_type: entity_type,
          id_type: id_type,
        },
      ],
    }).then((data: any) => {
      if (data && Array.isArray(data)) {
        setGameOtherInfo(
          data?.[0]?.value || {
            publisher: '',
            country: '',
          },
        );
      }
    });
  }, [gameInfo]);

  const isAllEditions = useMemo(() => {
    return id_type === 'unified_id' && entity_type === 'mobile';
  }, [id_type, entity_type]);

  const { publisher, country } = useMemo(() => {
    const { publisher, country } = gameOtherInfo || {};
    return { publisher, country };
  }, [gameOtherInfo]);

  if (!gameInfo) return null;

  return (
    <div className="header-flex">
      <RenderGameIcon
        gameInfo={gameInfo}
        className="header-img"
      ></RenderGameIcon>

      <div className="header-context">
        <div className="context-title">{entity_name}</div>

        <div className="context-flex">
          {country && (
            <RegionCountryItem
              iconClassName="desc-img"
              showText={false}
              market={country}
            ></RegionCountryItem>
          )}

          <span className="desc-text">
            {publisher && initialUpperCase(publisher)}
          </span>
        </div>
        <div className="tip-flex">
          <SvgIcon
            className="tip-svg"
            type={
              entity_type == 'mobile'
                ? 'other-icon'
                : entity_type == 'pc'
                ? 'monitor'
                : 'merit'
            }
          />
          <span className="tip-text">
            {isAllEditions
              ? formatMessage({ id: 'All Editions' })
              : formatMessage({ id: 'Editions' }) + '：' + entity_name}
          </span>
        </div>
      </div>
    </div>
  );
}
